import angular from 'angular';
import template from './modalForm.html';

class ModalFormController {

    $onInit() {
        this.item = this.resolve.item;
        this.view = this.resolve.view;
        this.formClass = this.resolve.formClass || 'horizontal';
        this.clone = angular.copy(this.item);
    }

    submit(item) {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.close({$value: item});
    };

    cancel() {
        this.dismiss({$value: 'cancel'});
    };
}

const ModalFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: ModalFormController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};


export {ModalFormComponent};



// WEBPACK FOOTER //
// ./app/components/common/crud/form/modalForm.component.js